import Vue from 'vue';
import Vuex from 'vuex';
// import user from './modules/user';
import system from './modules/system';
import vuexAlong from 'vuex-along';

Vue.use(Vuex);

export default new Vuex.Store({
    getters: {
        system_data: state => state.system.system_data || {},
        prev_page: state => state.system.prev_page
    },
    modules: {
        // user,
        system
    },
    plugins: [vuexAlong()]
});
